import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { Link } from 'react-router-dom';
import { Calculator } from 'lucide-react';

const FinancialPlanningPage = () => {
  const calculators = [
    {
      title: 'Retirement Planner',
      description: 'Set retirement corpus, estimate monthly expenses, and calculate monthly SIP investments needed.',
      icon: '🏝️'
    },
    {
      title: 'Portfolio Planner',
      description: 'Plan investments across asset classes, set retirement goals, and estimate post-retirement withdrawals.',
      icon: '📈'
    },
    {
      title: 'Business Planning',
      description: 'Know your growth goals, plan stable income post-retirement, and build exit strategies with SIP.',
      icon: '💼'
    },
    {
      title: 'SWP Calculator',
      description: 'Calculate retirement corpus, monthly withdrawal amounts, and optimize withdrawal strategy.',
      icon: '💰'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black">
      <Navbar />
      
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-2xl mb-6">
              <Calculator className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
              Retirement Planner
            </h1>
            <p className="text-lg text-white/70 max-w-3xl mx-auto">
              Assess your finances and plan for goals like retirement or education with personalized clarity.
            </p>
          </div>

          <div className="mb-16 bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10">
            <h2 className="text-2xl font-bold text-white mb-4">Why Financial Planning Matters</h2>
            <p className="text-white/70 mb-4">
              Financial planning helps you assess your current financial situation and create a roadmap for achieving your long-term goals. Our calculators help you:
            </p>
            <ul className="space-y-2 text-white/70">
              <li className="flex items-start gap-2">
                <span className="text-white mt-1">✓</span>
                <span>Understand required investment amounts for specific goals</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-white mt-1">✓</span>
                <span>Estimate potential returns based on different scenarios</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-white mt-1">✓</span>
                <span>Plan realistic timelines for achieving financial milestones</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-white mt-1">✓</span>
                <span>Make informed decisions about savings and investments</span>
              </li>
            </ul>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {calculators.map((calc, index) => (
              <div key={index} className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-300">
                <div className="text-5xl mb-4">{calc.icon}</div>
                <h3 className="text-2xl font-bold text-white mb-3">{calc.title}</h3>
                <p className="text-white/70 mb-6">{calc.description}</p>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 text-white hover:text-white/70 transition-colors"
                >
                  <span>Calculate Now</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FinancialPlanningPage;